import React, { useEffect, useRef, useState } from "react";
/* eslint-disable import/no-anonymous-default-export */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow, } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-coverflow';


import 'swiper/css/autoplay';
import './index.css';
import useIsMobileAndPortrait from "../../../../hooks/useIsMobile";
import { secureUrl } from "../../../../utils/sortArray/secureUrl";



const CarouselChampions = ({championsFromTournament, tournament})=>{
        const [numerSlides, SetNumberSlides] = useState(0)
        const  carouselRef= useRef()
        const imgChampionsRef = useRef(null)
        const getNumberOfSlides = ()=>{
            const getNumber = carouselRef.current?.offsetWidth / (imgChampionsRef.current?.offsetWidth || 400 + 100)
            SetNumberSlides(getNumber.toFixed(1))
        }
      const { isMobile, isPortrait} = useIsMobileAndPortrait();

        useEffect(()=>{
            if(!carouselRef.current) return
            getNumberOfSlides();
    
        },[carouselRef])
    
        useEffect(()=>{
            window.addEventListener('resize', ()=>{
                getNumberOfSlides();
            })
    
            return ()=> window.removeEventListener('resize', ()=>{})
    
        },[])



        const renderChampionsTeams = ()=>{
            return championsFromTournament?.map((championTeam, index)=>(createSlide(championTeam)))

        }
        function createSlide(champion) {
  return (
    <SwiperSlide>
        <div className="champion-card-container">
            <img ref={imgChampionsRef} className="img-card-champion-team"  src={`${secureUrl(champion?.imgChampion)}?ts=${champion?._id}`} /> 
            <div>
             <img className="img-card-trophy" src={secureUrl(tournament?.imgTrophy)} />
            <p>{champion?.name} - {champion?.year}</p>
            </div>

        </div>
    </SwiperSlide>
  );
}

    return(
        <div ref={carouselRef}>
     <Swiper
             effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: isMobile && isPortrait ? 400 : 250,
          modifier: 2.5,
        }}
      modules={[Navigation, Pagination, Autoplay,EffectCoverflow]}
      slidesPerView={numerSlides}
      navigation
      autoplay={{ delay: 1500 }}
    >
      {renderChampionsTeams()}
    </Swiper>
        </div>
    )
}

export default CarouselChampions